import styled from "styled-components";

export const FormWrapper = styled.div`
  padding: 4rem;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--homeBG);
  @media (max-width: 450px) {
    background: #e6f7ff;
    padding: 0;
  }
`;

export const ShipmentForm = styled.div`
  max-width: 800px;
  width: 100;
  background-color: #ffffff;
  padding: 30px;
  border-radius: 15px;
  /* box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); */
  @media (max-width: 450px) {
    border-radius: 0;
  }
`;
